import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { space, colors, radii } from 'style/config';
import {
    Box, Flex, Grid, Divider
} from 'components/ui';
import UIUtils from 'utils/UI';

const { SKELETON_ANIMATION } = UIUtils;

/**
 * Placeholder skeleton for AutoReplenishmentSummary shown while subscriptions are loading.
 */
const AutoReplenishmentSummarySkeleton = () => (
    <Box css={styles.container}>
        <Grid css={styles.content}>
            <Box>
                <Box css={[styles.shimmerBar, styles.titleBar]} />
                <Box css={[styles.shimmerBar, styles.statusBar]} />
            </Box>
        </Grid>
        <Divider />
        <Grid css={styles.content}>
            <Box css={styles.items}>
                {[0, 1].map(i => (
                    <Flex
                        key={i}
                        css={styles.item}
                    >
                        <Box css={styles.iconPlaceholder} />
                        <Box css={[styles.shimmerBar, styles.labelBar]} />
                        <Box css={[styles.shimmerBar, styles.valueBar]} />
                    </Flex>
                ))}
            </Box>
        </Grid>
        <Divider />
        <Box css={[styles.shimmerBar, styles.footer]} />
    </Box>
);

const styles = {
    container: {
        backgroundColor: colors.nearWhite,
        padding: `${space[1]}px ${space[4]}px ${space[3]}px ${space[4]}px`,
        marginTop: space[4],
        borderRadius: space[1]
    },
    content: {
        gap: 0,
        gridTemplateColumns: '1fr auto',
        padding: `${space[3]}px 0`
    },
    items: {
        display: 'flex',
        flexDirection: 'column',
        gap: space[3]
    },
    item: {
        alignItems: 'center'
    },
    shimmerBar: [
        {
            height: 10,
            borderRadius: radii[2]
        },
        SKELETON_ANIMATION
    ],
    titleBar: {
        width: '35%',
        height: 14,
        marginBottom: space[3]
    },
    statusBar: {
        width: '55%',
        height: 12,
        marginBottom: space[1]
    },
    iconPlaceholder: [
        {
            width: 25,
            height: 25,
            borderRadius: '50%',
            flexShrink: 0,
            marginRight: space[3]
        },
        SKELETON_ANIMATION
    ],
    labelBar: {
        width: '40%'
    },
    valueBar: {
        width: '20%',
        marginLeft: 'auto'
    },
    footer: {
        height: 14,
        marginTop: space[4],
        marginBottom: space[1],
        width: '15%'
    }
};

export default wrapFunctionalComponent(AutoReplenishmentSummarySkeleton, 'AutoReplenishmentSummarySkeleton');
